import "./Home.scss";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Container } from "@/covaltech-react-ui";

import useScrollAnimation from "../../hooks/useScrollAnimation";
import About from "./About/About";
import Contact from "./Contact/Contact";
import Faq from "./Faq/Faq";
import Hero from "./Hero/Hero";
import OpenSource from "./OpenSource/OpenSource";
import Portfolio from "./Portfolio/Portfolio";
import Services from "./Services/Services";
import Team from "./Team/Team";

const Home = () => {
  useScrollAnimation();
  const { hash, key } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    const t = window.setTimeout(() => {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => window.clearTimeout(t);
  }, [hash, key]);

  return (
    <Container className="home">
      <Hero />
      <Services />
      <About />
      <Team />
      <OpenSource />
      <Portfolio />
      <Faq />
      <Contact />
    </Container>
  );
};

export default Home;
